import styled from "styled-components";
import { Accordion } from "react-bootstrap";
import { } from "../../../constants";

export const AccordionToggle = styled(Accordion.Toggle)``;
